<template>
    <div :id="`toolbar_${id}`" class="toolbar-list">

        <template v-for="button in filteredButtons">
            <tooltipUI :key="`tooltip_${id}_${button.id}`" :text="button.hint" v-show="buttonShow(button.id)" 
                :disabled="!buttonEnabled(button.id)" placement="bottom">
                <flatIconButtonCMP :id="`bt_${button.id}`" class="button"
                    :disabled="!buttonEnabled(button.id)" :loading="isButtonLoading(button.id)"
                    :data-is-active="Boolean(buttonActive(button.id))" @click="buttonClick(button.id)" :iconSize="18"
                    :style="{
                        'color': buttonColor(button.id),
                    }">
                    <template #svgIcon>
                        <component :is="iconComponents[button.icon]" />
                    </template>
                </flatIconButtonCMP>
            </tooltipUI>
        </template>
    </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import { undoRedoHistory } from '@/globals/undoRedo';
import { gConsts } from '@/globals/gConsts';
import { utils } from '@/globals/utils';
import { evtBus } from '@/main';

import tooltipUI from '@/components/ui/tooltip.vue';
import flatIconButtonCMP from '@/components/ui/button/flatIconButton.vue';
import { defineAsyncComponent } from 'vue';
import { jobMixin } from '@/mixins/job';

// -----------------------------------------------------------------

export default {
    name: 'toolbarCMP',

    components: {
        flatIconButtonCMP,
        tooltipUI
    },

    // -----------------------------------------------------------------\

    props: {
        buttons: Array,
        id: String
    },

    mixins: [jobMixin],

    // -----------------------------------------------------------------\

    data() {
        return {
            currentLayerToolbar: [],
            permissions: {
                delTool: false
            },
            loadingButtonId: null
        }
    },

    // -----------------------------------------------------------------\

    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_togglesImgOrigin',
            'GET_togglesCrossHair',
            'GET_execModeVIEW',
            'GET_nodesArray',
            'GET_jobInfoType',
            'GET_appToolbars'
        ]),

        filteredButtons() {
            // if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS && this.currentLayerToolbar) {
            //     return this.buttons.filter(button => this.currentLayerToolbar.includes(button.id) || button.id == gConsts.ui.toolbar.buttons.DEL_TOOL);
            // }

            return this.buttons;
        },

        iconComponents() {
            const icons = {};
            this.buttons.forEach(button => {
                icons[button.icon] = this.loadIconComponent(button.icon);
            });
            return icons;
        }
    },

    // -----------------------------------------------------------------\

    methods: {
        ...mapActions([
            'ACT_toolDelete',
            'ACT_jobUpdate',
            'ACT_runtimeUpdate',
            'ACT_uiUpdate',
        ]),

        // -----------------------------------------------------------------

        loadIconComponent(iconName) {
            if (!iconName)
                return null;
            return defineAsyncComponent(() => import(`@/assets/icons/toolbar/${iconName}.svg`));
        },

        // -----------------------------------------------------------------

        buttonShow: function (buttonId) {
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                if (buttonId == gConsts.ui.toolbar.buttons.DEL_TOOL)
                    return true;
                return this.currentLayerToolbar.includes(buttonId);
            }

            switch (buttonId) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN:
                    return this.GET_activeElem && (this.GET_activeElem.imgOrigin != null);
                case gConsts.ui.toolbar.buttons.RESET_JOB:
                    return this.GET_jobInfoType == gConsts.job.info.type.EDIT;
            }

            return true;
        },

        // -----------------------------------------------------------------

        buttonClick: function (button, toolType) {
            if (!this.buttonEnabled(button)) {
                return;
            }

            switch (button) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN:
                    this.ACT_uiUpdate({ toggles: { imgOrigin: !this.GET_togglesImgOrigin } });
                    break;

                case gConsts.ui.toolbar.buttons.FIT_TO_WA:
                    evtBus.$emit('evt_medidor_fitToWorkArea');
                    break;

                case gConsts.ui.toolbar.buttons.SAVE_IMG:
                    this.ACT_jobUpdate({});
                    break;

                case gConsts.ui.toolbar.buttons.CROSS_HAIR:
                    this.ACT_uiUpdate({ toggles: { crossHair: !this.GET_togglesCrossHair } });
                    break;

                case gConsts.ui.toolbar.buttons.UNDO:
                    undoRedoHistory.undo();
                    break;

                case gConsts.ui.toolbar.buttons.REDO:
                    undoRedoHistory.redo();
                    break;

                case gConsts.ui.toolbar.buttons.DEL_TOOL:
                    evtBus.$emit('evt_toolAction', 'deleteTool');
                    // this.ACT_toolDelete(); 
                    break;

                case gConsts.ui.toolbar.buttons.EXEC_MODE:
                    this.ACT_runtimeUpdate({ execMode: (this.GET_execModeVIEW ? gConsts.rt.execModes.WORK : gConsts.rt.execModes.VIEW) });
                    break;

                case gConsts.ui.toolbar.buttons.FULL_SCREEN:
                    this.toggleFullscreen(this.$parent.$parent.$refs.rootElem);
                    break;
                case gConsts.ui.toolbar.buttons.RESET_JOB:
                    this.onResetJob();
                    break;

                default:
                    this.ACT_uiUpdate({
                        toolbar: {
                            toolType: utils.getButtonToolType(button),
                            button: button
                        }
                    });
            }
        },

        // -----------------------------------------------------------------

        toggleFullscreen(elem) {
            if (document.fullscreenElement) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else {
                    this.fullScreen_pollyfill('exit');
                }
            } else {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else {
                    this.fullScreen_pollyfill('req', elem);
                }
            }
        },

        // -----------------------------------------------------------------

        fullScreen_pollyfill: function (action, elem) {
            switch (action) {
                case 'req':
                    if (elem.mozRequestFullScreen) { /* Firefox */
                        elem.mozRequestFullScreen();
                    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                        elem.webkitRequestFullscreen();
                    } else if (elem.msRequestFullscreen) { /* IE/Edge */
                        elem.msRequestFullscreen();
                    }
                    break;

                case 'exit':
                    if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari & Opera */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    break;
            }
        },

        // -----------------------------------------------------------------

        buttonActive: function (button) {
            var active = false;
            // TODO: Desabilitado por enquanto ate refazer o undo/redo do store.
            if (this.id == gConsts.ui.toolbar.ids.UNDO_REDO) {
                return false;
            }

            switch (button) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN:
                    active = this.GET_togglesImgOrigin;
                    break;

                case gConsts.ui.toolbar.buttons.CROSS_HAIR:
                    active = this.GET_togglesCrossHair;
                    break;

                case gConsts.ui.toolbar.buttons.UNDO:
                    active = undoRedoHistory.undoActive;
                    break;

                case gConsts.ui.toolbar.buttons.REDO:
                    active = undoRedoHistory.redoActive;
                    break;

                case gConsts.ui.toolbar.buttons.EXEC_MODE:
                    active = this.GET_execModeVIEW;
                    break;

                default:
                    active = (this.$store.state.ui.toolbar.button == button);
            }

            return active;
        },

        buttonEnabled(buttonId) {
            // TODO: Desabilitado por enquanto ate refazer o salvamento do relatório.
            if (this.id == gConsts.ui.toolbar.ids.IMG_TOOLS && buttonId == gConsts.ui.toolbar.buttons.SAVE_IMG) {
                return false;
            }
            // TODO: Desabilitado por enquanto ate refazer o undo/redo do store.
            if (this.id == gConsts.ui.toolbar.ids.UNDO_REDO) {
                return false;
            }
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                if (this.currentLayerToolbar.length == 0) {
                    return false;
                }
                if (buttonId == gConsts.ui.toolbar.buttons.DEL_TOOL) {
                    return this.permissions.delTool;
                }
                return this.currentLayerToolbar.includes(buttonId);
            }

            return true;
        },

        // -----------------------------------------------------------------

        buttonColor: function (button) {
            return (button == gConsts.ui.toolbar.buttons.DEL_TOOL) ? '#fa7575' : '';
        },

        // -----------------------------------------------------------------

        isButtonLoading: function (buttonId) {
            return this.loadingButtonId == buttonId;
        },

        setLoadingButton: function (buttonId) {
            this.loadingButtonId = buttonId;
        },

        clearLoadingButton: function () {
            this.loadingButtonId = null;
        },

        onResetJob: async function () {
            this.setLoadingButton(gConsts.ui.toolbar.buttons.RESET_JOB);
            try {
                await this.resetJob();
            } finally {
                this.clearLoadingButton();
            }
        }
    },

    // Lifecycle hooks
    created() {
    },

    mounted() {
        evtBus.$on('evt_activateNode', (payload) => {
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                const layerNode = this.GET_nodesArray.find(node => node.id == payload.layer);
                const labelNode = this.GET_nodesArray.find(node => node.id == payload.label);
                if (layerNode && layerNode.layerTools && labelNode) {
                    this.currentLayerToolbar = layerNode.layerTools.toolbar || [];
                } else {
                    this.currentLayerToolbar = [];
                }

                // Deseleciona o button tool se ele não fazer parte do toolbar da layer selecionada
                if (![-1, gConsts.ui.toolbar.buttons.DEL_TOOL].includes(this.$store.state.ui.toolbar.button) &&
                    this.buttons.find(button => button.id == this.$store.state.ui.toolbar.button) &&
                    !this.currentLayerToolbar.includes(this.$store.state.ui.toolbar.button)) {
                    this.ACT_uiUpdate({
                        toolbar: {
                            button: -1,
                            toolType: gConsts.tool.attrib.types.NO_TOOL
                        }
                    });
                }

                // Seleciona o botao se so existir um
                if (this.currentLayerToolbar.length > 0 &&
                    (this.$store.state.ui.toolbar.button == -1 || !this.GET_appToolbars[this.id].map(button => button.id).includes(this.$store.state.ui.toolbar.button))) {
                    this.ACT_uiUpdate({
                        toolbar: {
                            button: utils.getButtonToolType(this.currentLayerToolbar[0]),
                            toolType: this.currentLayerToolbar[0]
                        }
                    });
                }
            }
        });

        evtBus.$on('evt_tool_onChangeSelected', (payload) => {
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                this.permissions.delTool = payload.toolId != null;
            }
        });
    },

    beforeDestroy() {
    }
}
</script>

<style scoped>
.toolbar-list {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.toolbar-list .button {
    padding: var(--spacing-sm);
    border-radius: var(--radius-sm);
}

.toolbar-list .button[data-is-active="true"] {
    color: var(--color-white);
    background-color: var(--color-primary);
}
</style>
